<template>
  <div v-html="value" />
</template>

<script>
export default {
  name: 'MoBlockView',

  props: {
    value: {
      type: String,
      default: ''
    }
  }
}
</script>
